// tslint:disable:max-line-length
import { Injectable, ComponentRef, ComponentFactoryResolver, ApplicationRef, Injector, Type, EmbeddedViewRef } from '@angular/core';
import { MaxDialogRef, MaxDialogConfig } from '../models/max-dialog-ref';
import { MaxDialogInjector } from '../models/max-dialog-injector';
import { MaxDialogComponent } from '../max-dialog.component';
import { MaxDialogModule } from '../max-dialog.module';
import { first } from 'rxjs/operators';

@Injectable({
    providedIn: MaxDialogModule
})
export class MaxDialogService {
    dialogComponentRef: ComponentRef<MaxDialogComponent>;

    constructor(private componentFactoryResolver: ComponentFactoryResolver, private appRef: ApplicationRef, private injector: Injector) { }

    public open<T, D>(componentType: Type<T>, config?: MaxDialogConfig<D>): MaxDialogRef<T> {
        if (!document) { throw new Error('Document is not defined, Make sure you are in a browser environment'); }
        const dialogRef = new MaxDialogRef<T>();

        dialogRef.afterCLosed.pipe(first()).subscribe(() => {
            this.removeDialog();
        });

        const componentRef = this.componentFactoryResolver.resolveComponentFactory(MaxDialogComponent).create(this.getDialogInjector(dialogRef, config));

        this.appRef.attachView(componentRef.hostView);

        document.body.appendChild((componentRef.hostView as EmbeddedViewRef<any>).rootNodes[0] as HTMLElement);

        componentRef.instance.childComponentType = componentType;

        this.dialogComponentRef = componentRef;

        return dialogRef;
    }

    private getDialogInjector<T, D>(dialogRef: MaxDialogRef<T>, config: MaxDialogConfig<D>): MaxDialogInjector {
        const weakMap = new WeakMap();
        weakMap.set(MaxDialogConfig, config);
        weakMap.set(MaxDialogRef, dialogRef);
        return new MaxDialogInjector(this.injector, weakMap);
    }

    private removeDialog(): void {
        this.appRef.detachView(this.dialogComponentRef.hostView);
        this.dialogComponentRef.destroy();
    }

}
